'use client';

// Cookie consent notice. Matches the published /cookies policy, which already
// documents a `cookieConsent` choice (localStorage) with Accept/Decline.
// The public site uses only essential cookies + self-hosted fonts (no analytics
// or advertising), so the choice is recorded for transparency; nothing extra is
// loaded either way. Rendered from <PublicFooter/> (public marketing pages only).

import { useEffect, useState } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem('cookieConsent')) setVisible(true);
    } catch {
      /* localStorage unavailable (private mode) — don't block the page */
    }
  }, []);

  if (!visible) return null;

  const choose = (value: 'accepted' | 'declined') => {
    try {
      localStorage.setItem('cookieConsent', value);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie notice">
      <p>
        We use only essential cookies needed to make this site work. We don&rsquo;t use advertising
        or third-party tracking. See our <a href="/cookies">Cookie Policy</a>.
      </p>
      <div className="cookie-consent-actions">
        <button type="button" className="cookie-decline" onClick={() => choose('declined')}>
          Decline
        </button>
        <button type="button" className="cookie-accept" onClick={() => choose('accepted')}>
          Accept
        </button>
      </div>
    </div>
  );
}
